import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './routes';

// Create the router instance
const router = createBrowserRouter(routes);

// Router component to be used in the app
export function AppRouter() {
  return <RouterProvider router={router} />;
}

// Export guards and routes for external use
export * from './guards';
export { routes };
